const token = Wiz.AuthHooks.GetToken()
const sysLanguage = localStorage.getItem('lang') || 'zh'
axios.defaults.headers.common.Authorization = `Bearer ${token}`
axios.defaults.headers.common['Accept-Language'] = sysLanguage
const uploadInstance = axios.create()
const wizStandardInstance = axios.create()
const diyInstance = axios.create()
// eslint-disable-next-line import/no-mutable-exports
let currentEnv = {}
const InstanceInit = (conf /* currentEnv */) => {
  // 上传接口
  uploadInstance.defaults.baseURL = conf.VUE_APP_UPLOAD_SERVER
  // RESOURCES接口
  wizStandardInstance.defaults.baseURL = conf.VUE_APP_STANDARD_SERVER
  // 低代码
  diyInstance.defaults.baseURL = conf.VUE_APP_DIY_SERVER
  currentEnv = conf
}
const config = Wiz.GetModuleConfig('legacy-resource')
InstanceInit(config.currentEnv)
export { InstanceInit, currentEnv, uploadInstance, wizStandardInstance, diyInstance }
